export default function () {
  const widgetName = 'infographicSection';
  const widgetOpts = infographicSectionOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function customStyle() {




        $(`#${widgetName} .card-widget-item`).each(function (x) {
          $(this).find('.buttonwrap').remove();

          let windowSize = window.innerWidth;
          let dataAos;
          let dataAosDelay;
          let animationType = (windowSize >= 1100) ? "fade-left" : "fade-right";

          if (x !== 2) {
            dataAos = (x === 0 || x === 3) ? "fade-right" : animationType;
            dataAosDelay = (windowSize >= 800) ? "600" : "100";
          } else {
            dataAos = "zoom-in";
            dataAosDelay = (windowSize >= 1100) ? "1200" : "10";
          }

          $(this).attr({
            "data-aos": dataAos,
            "data-aos-easing": "ease-in-out",
            "data-aos-duration": "180",
            "data-aos-delay": dataAosDelay,
            "data-aos-once": "true",
            "data-aos-offset": "200"
          });
        });
      }

      customStyle();

    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW!'
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: false,
      text: 'Learn more'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true
  });
}